import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';
import GenericPageLayout from '../generic-page-layout';

const SignUpConfirmation = props => {
  const {
    existingCompanyId,
  } = props;

  return (
    <GenericPageLayout
      tableInfo={
        <div>
          <div>
            <p style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.54)' }} className='checkYourEmail'>
              You're almost done. Check your email.
            </p>
            <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>
              {
                existingCompanyId ? "Once you confirm your email we'll notify your administrator to approve your access to your company's account. "
                  : "We've sent you an email with a confirmation link to activate your account."
              }
            </p>
            {existingCompanyId &&
              <p style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }}>
                Patience is not simply the ability to wait - it's how we behave while we're waiting. - Joyce Meyer
              </p>}
          </div>
          <div style={{ marginTop: '15%' }}>
            <FontIcon
              className={'tc-icon-paperplane'}
              color={'#27cfc3'}
              style={{ fontSize: '200px' }}
            />
          </div>
        </div>
      }
      outsideTable
      hideNextButton
      footer={
        <p style={{ margin: '15% auto', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', width: '55%', display: 'block' }}>
          Need help? Click <a href="mailto:support@tourconnect.com?subject=Help Signing Up">here</a> to contact our support team.
        </p>
      }
    />
  );
};

SignUpConfirmation.propTypes = {
  existingCompanyId: PropTypes.string,
};

export default SignUpConfirmation;



// WEBPACK FOOTER //
// ./src/app/components/signup/confirmation/confirm-sign-up.jsx